import api from "apis/payPeriods";
import { WebApiRequest, HTTP_GET } from "tools/webservice";

export const getBonusWeeks = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getBonusWeeks(),
  successCallback,
  mountedRef,
});
